import React, { useEffect, useRef } from 'react';
import { IconChevronRight } from '@carnica/graphics';
import { cnBem } from '@carnica/utils';
import { Button, Text } from '@carnica/ui-kit';
import { NotificationIcon } from "./components/NotificationIcon";
import styles from "./styles.pcss";
var cnNotification = cnBem('notification-item', styles);
export var NotificationItem = function NotificationItem(_ref) {
  var notification = _ref.notification,
    isTop = _ref.isTop,
    height = _ref.height,
    setHeight = _ref.setHeight,
    onClick = _ref.onClick,
    onClose = _ref.onClose,
    isExpanded = _ref.isExpanded;
  var ref = useRef(null);
  var changeStyle = ref.current && !isTop && !isExpanded;
  var handleClick = function handleClick() {
    onClose();
    if (window) {
      window.location.href = notification.href || "".concat(window.location.origin, "/customers/products/elk/tab/notifications/?type=").concat(notification.type);
    }
  };
  useEffect(function () {
    if (ref.current && isTop) {
      setHeight(ref.current.clientHeight);
    }
  });
  return /*#__PURE__*/React.createElement("li", {
    ref: ref,
    style: changeStyle ? {
      marginTop: -height,
      height: height
    } : {},
    "data-t-id": "Notifications-NotificationItem"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cnNotification({
      pointer: !isExpanded
    }, ['notification-button']),
    onClick: onClick
  }, /*#__PURE__*/React.createElement(NotificationIcon, {
    type: notification.type,
    "data-t-id": "Notifications-NotificationItem"
  }), /*#__PURE__*/React.createElement("div", {
    className: cnNotification(null, ['main'])
  }, /*#__PURE__*/React.createElement(Text, {
    className: cnNotification(null, ['text']),
    size: "14",
    tagName: "div"
  }, notification.text), isExpanded && /*#__PURE__*/React.createElement(Button, {
    className: cnNotification(null, ['action-button']),
    iconLeft: IconChevronRight,
    onClick: handleClick,
    onlyIcon: true,
    type: "button"
  }))));
};